/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


const STORAGE_KEY = 'selectedCategoryFilters';

// Helpers
function getStoredSelectedIds() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? JSON.parse(stored) : [];
}

function saveSelectedIds(ids) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
}

function updateStoredSelection(filterId, isSelected) {
  let selectedIds = getStoredSelectedIds();
  if (isSelected && !selectedIds.includes(filterId)) {
    selectedIds.push(filterId);
  } else if (!isSelected && selectedIds.includes(filterId)) {
    selectedIds = selectedIds.filter(id => id !== filterId);
  }
  saveSelectedIds(selectedIds);
}

function applyCardVisualState(card, isSelected) {
  const img = card.querySelector('img');
  if (!img) return;
  card.dataset.clicked = isSelected ? 'true' : 'false';
  img.style.border = isSelected ? '2px solid #ff71ab' : '';
  const removeBox = card.querySelector('.remove-box');
  if (removeBox) {
    removeBox.style.display = isSelected ? 'block' : 'none';
  }
}

document.addEventListener('click', (e) => {
  const card = e.target.closest('.category-card');
  if (card) {
    const filterId = card.getAttribute('data-filter-id');
    const input = document.querySelector(`.filter-group.CategoryFilter input[value="${filterId}"]`);
    if (input) {
      input.click(); 
    }
  }
});

document.addEventListener('click', (e) => {
  if (e.target.matches('.filter-group.CategoryFilter input[type="checkbox"]')) {
    const input = e.target;
    const filterId = input.value;
    const card = document.querySelector(`.category-card[data-filter-id="${filterId}"]`);
    if (!card) return;

    // Predict state after click
    const isNowSelected = !(card.dataset.clicked === 'true');
    applyCardVisualState(card, isNowSelected);
    updateStoredSelection(filterId, isNowSelected);
  }

  if (
    e.target.closest('a.active__filters__remove[data-filter-update-url]')
  ) {
    const link = e.target.closest('a.active__filters__remove');
    const tagTextEl = link.querySelector('small');
    if (!tagTextEl) return;

    const tagText = tagTextEl.textContent.trim().toLowerCase();

    document.querySelectorAll('.category-card').forEach(card => {
      const cardTextEl = card.querySelector('p');
      if (!cardTextEl) return;

      const cardText = cardTextEl.textContent.trim().toLowerCase();

      if (cardText === tagText) {
        applyCardVisualState(card, false);

        const filterId = card.getAttribute('data-filter-id');
        if (filterId) {
          updateStoredSelection(filterId, false);
        }
      }
    });
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const selectedIds = getStoredSelectedIds();
  selectedIds.forEach(filterId => {
    const card = document.querySelector(`.category-card[data-filter-id="${filterId}"]`);
    if (card) applyCardVisualState(card, true);
  });
});

(function() {
  // Add custom code below this line
  const expandButton = document.querySelector('.expand-button');
  const collapseButton = document.querySelector('.collapse-button');
  const visibleContent = document.querySelector('.visible-content');
  const hiddenContent = document.querySelector('.hidden-content');
  const overlay = document.querySelector('.gradient-overlay');

    console.log(expandButton);
    if(expandButton) {
        hiddenContent.style.maxHeight = '0';
        hiddenContent.style.overflow = 'hidden';
        expandButton.addEventListener('click', function () {
            overlay.classList.add('hidden');  
            hiddenContent.classList.add('revealed');  
        });
    
        collapseButton.addEventListener('click', function () {
            hiddenContent.classList.remove('revealed'); 
            overlay.classList.remove('hidden');  
        });
    }



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
